import useQueryParam from "@casino/client/hooks/router/useQueryParam";
import useFeature from "@casino/legacy/client/hooks/feature/useFeature";
import isExternalUrl from "@casino/shared/utils/isExternalUrl";
import COUNTRY_CODE from "@workspace/casino_config/cookies/COUNTRY_CODE";
import { getCookie } from "@workspace/cookies/browser";
import { usePathname } from "next/navigation";

const regex = /[^a-z0-9\][\\\-_/]/gi;

const useRedirectUrl = () => {
  const [redirect = "/"] = useQueryParam("redirect");
  const pathname = usePathname();
  const shouldRedirect =
    pathname === "/register" || pathname === "/complete-registration";
  const isRegistrationCashierRedirect = useFeature(
    "isRegistrationCashierRedirect",
  );
  const isWalletLandingPageEnabled = useFeature("isWalletLandingPageEnabled");
  const countryCode = getCookie(COUNTRY_CODE);
  const isWalletLanding = isWalletLandingPageEnabled || countryCode === "TR";

  if (isExternalUrl(redirect)) {
    return "/";
  }

  if (shouldRedirect && isRegistrationCashierRedirect) {
    return isWalletLanding ? "/?c=wallet_landing" : "/?c=home";
  }

  const sanitizedRedirect = redirect.replaceAll(regex, "");
  return sanitizedRedirect ? sanitizedRedirect : "/";
};

export default useRedirectUrl;
